import {
  Box,
  Chip,
  Grid,
  MenuItem,
  Tooltip,
  Typography,
} from '@material-ui/core';
import {
  CustomCheckbox,
  CustomRadioButtons,
  StyledSwitch as CustomSwitch,
  CustomTable,
  CustomTextField,
} from '@uml/uml-components';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import React, { useEffect } from 'react';
import { addVote, canVote, verified } from '../../services/votes';
import { checkToken, getProjectsApproved } from '../../services/projects';
import { onlyLettersRegex, phoneRegex } from '../../utilities/regex';

import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Button from '@material-ui/core/Button';
import ClearIcon from '@material-ui/icons/Clear';
import DialogWIthError from './DialogWithError';
import DoneIcon from '@material-ui/icons/Done';
import FaQ from './FaQ';
import IconButton from '@material-ui/core/IconButton';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import MyLocationIcon from '@material-ui/icons/MyLocation';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import SuccessStep from './SuccessStep';
import Truncate from '../../utilities/Truncate';
import TrustedProfile from './TrustedProfile';
import Wrapper from '../../components/Wrapper';
import clsx from 'clsx';
import { useSnackbar } from 'notistack';
import { useStyles } from './style';
import { useTheme } from '@material-ui/core/styles';

const Votes = ({ editionId }) => {
  const classes = useStyles();
  const theme = useTheme();
  const searchParams = new URLSearchParams(window.location.search);
  const methodsFirstStep = useForm();
  const methodsSecondStep = useForm();
  const methodsThirdStep = useForm();
  const { enqueueSnackbar } = useSnackbar();
  const [documentType, setDocumentType] = React.useState('');
  const [contactType, setContactType] = React.useState('');
  const [dialogIsOpen, setDialogIsOpen] = React.useState(false);
  const [showSecondStep, setShowSecondStep] = React.useState(false);
  const [showThirdStep, setShowThirdStep] = React.useState(false);
  const [showSuccessStep, setShowSuccessStep] = React.useState(false);
  const [tokenValue, setTokenValue] = React.useState(null);

  const [selected, setSelected] = React.useState([]);
  const [availableVotesForCity, setAvailableVotesForCity] = React.useState(0);
  const [selectedCityProjects, setSelectedCityProjects] = React.useState([]);
  const [availableVotesForDistrict, setAvailableVotesForDistrict] =
    React.useState(0);
  const [selectedDistrictProjects, setSelectedDistrictProjects] =
    React.useState([]);
  const [count, setCount] = React.useState(0);
  const [approved, setApproved] = React.useState([]);
  const [filterData, setFilterData] = React.useState([]);
  const [user, setUser] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  const [wrongCharPhone, setWrongCharPhone] = React.useState('');
  const [showAgreementsError, setShowAgreementsError] = React.useState(false);
  const [votesAgreements, setVotesAgreements] = React.useState({
    agreements1: false,
    agreements2: false,
    agreements3: false
  })

  const agreementRequiredText = "Uzupełnij wymagane pole"

  const isAdult = useWatch({
    control: methodsFirstStep.control,
    name: 'is_adult',
  });


  const cityTypes = [
    'ogólnomiejski',
    'ogólnomiejski nieinwestycyjny',
    'ogólnomiejski inwestycyjny',
  ];

  const showWk = typeof show_wk !== 'undefined' ? show_wk : false;

  useEffect(() => {
    const checkTrustedProfile = async () => {
      const withTrusted = searchParams.get('withTrusted');

      const govError = () =>
        enqueueSnackbar('Wystąpił błąd podczas logowania profilem zaufanym', {
          variant: 'error',
        });
      if (withTrusted === 'True') {
        try {
          const { data } = await checkToken(editionId);
          if (data.can_vote && !data.voted) {
            setShowThirdStep(true);
            enqueueSnackbar('Możesz teraz oddać głos', {
              variant: 'success',
            });
          } else {
            setDialogIsOpen((data.can_vote && data.voted) || !data.can_vote);
          }
        } catch {
          govError();
        }
      } else if (withTrusted === 'False') {
        govError();
      }
    };
    checkTrustedProfile();
  }, []);

  // first step
  const formSubmit = async (data) => {
    const formData = {
      ...data,
      first_name: data.first_name.trim(),
      last_name: data.last_name.trim(),
      second_last_name: data.second_last_name.trim(),
      has_pesel: data.has_pesel === 'PESEL' || data.has_pesel === '',
      verification_value: data.verification_value.replaceAll(' ', ''),
    };
    setUser(formData);


    try {
      const { data } = await canVote(editionId, formData);
      setShowSecondStep(data.can_vote && !data.voted);
      setDialogIsOpen((data.can_vote && data.voted) || !data.can_vote);
      window.scrollTo(0, 0);
    } catch (e) {
      enqueueSnackbar(
        e.response?.data?.message
          ? e.response?.data?.message
          : 'Nie udało się oddać głosu',
        { variant: 'error' },
      );
    }
  };

  const refreshCode = async () => {
    try {
      await canVote(editionId, user);
    } catch (e) {
      enqueueSnackbar('Nie udało się oddać głosu', { variant: 'error' });
    }
  };

  const handleMask = (e) => {
    if (e.target.value.length >= 4) {
      e.target.value = e.target.value.slice(0, 4);
      e.preventDefault();
    }
  };

  const handleDocumentTypeChange = (event) => {
    setDocumentType(event.target.value);
  };

  const handleContactTypeChange = (event) => {
    setContactType(event.target.value);
  };

  const handleClose = () => {
    setDialogIsOpen(false);
  };

  const formRef = React.useRef();


  // second step
  const verficiationFormSubmit = async (data) => {
    const formData = {
      token: data.token.trim(),
      ...user,
    };

    try {
      const { data } = await verified(editionId, formData);
      if (data.status === 'success') {
        setTokenValue(formData.token);
        setShowThirdStep(true);
        setShowSecondStep(false);
        window.scrollTo(0, 0);
      }
      if (data.status === 'failed') {
        enqueueSnackbar(data.message, { variant: 'error' });
      }
    } catch (e) {
      enqueueSnackbar('Błąd weryfikacji, spróbuj ponownie', {
        variant: 'error',
      });
    }
  };

  // thrid step
  const handleSelectProject = (id, objType, number, title) => {
    if (cityTypes.includes(objType)) {
      const updateSelected = [...selectedCityProjects, id];
      setSelectedCityProjects(updateSelected);
      setAvailableVotesForCity(availableVotesForCity - 1);
    } else {
      const updateSelected = [...selectedDistrictProjects, id];
      setSelectedDistrictProjects(updateSelected);
      setAvailableVotesForDistrict(availableVotesForDistrict - 1);
    }
    const updateSelected = [...selected, { id, number, title, objType }];
    setSelected(updateSelected);
  };

  const fetchProjectsData = async (params) => {
    setLoading(true);

    try {
      const { data } = await getProjectsApproved(editionId, params);
      setApproved(data.results.projects);
      setCount(data.count);
      setAvailableVotesForCity(
        data.results.city_votes - selectedCityProjects.length,
      );
      setAvailableVotesForDistrict(
        data.results.district_votes - selectedDistrictProjects.length,
      );
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveSelectProject = (id, objType) => {
    if (cityTypes.includes(objType)) {
      const filteredAry = selectedCityProjects.filter((e) => e !== id);
      setSelectedCityProjects(filteredAry);
      setAvailableVotesForCity(availableVotesForCity + 1);
    } else {
      const filteredAry = selectedDistrictProjects.filter((e) => e !== id);
      setSelectedDistrictProjects(filteredAry);
      setAvailableVotesForDistrict(availableVotesForDistrict + 1);
    }
    const filteredAry = selected.filter((e) => e.id !== id);
    setSelected(filteredAry);
  };

  const actionGroup = (id, objType, number, title) => {
    return (
      <div>
        {!selectedCityProjects.includes(id) &&
        !selectedDistrictProjects.includes(id) ? (
          <IconButton
            aria-label='Wybierz ten projekt'
            onClick={() => handleSelectProject(id, objType, number, title)}
            disabled={
              cityTypes.includes(objType)
                ? availableVotesForCity === 0
                : availableVotesForDistrict === 0
            }
          >
            <AddCircleOutlineIcon />
          </IconButton>
        ) : (
          <IconButton
            aria-label='Usuń ten projekt'
            onClick={() => handleRemoveSelectProject(id, objType)}
          >
            <ClearIcon />
          </IconButton>
        )}
      </div>
    );
  };

  useEffect(() => {
    setFilterData([
      {
        name: 'project_range',
        label: 'filtruj po rodzaju projektu',
        multi: false,
        width: 100,
        menuItems: [
          <MenuItem
            value={JSON.stringify({
              value: 'ogólnomiejski',
              name: 'ogólnomiejski',
            })}
          >
            ogólnomiejski
          </MenuItem>,
          <MenuItem
            value={JSON.stringify({
              value: 'dzielnicowy',
              name: 'dzielnicowy',
            })}
          >
            dzielnicowy
          </MenuItem>,
        ],
        values: [
          { value: 'ogólnomiejski', name: 'ogólnomiejski' },
          { value: 'dzielnicowy', name: 'dzielnicowy' },
        ],
      },
    ]);
  }, []);

  const [isDesktop, setIsDesktop] = React.useState(false);
  const desktop = window.matchMedia('(min-width: 1200px)');

  useEffect(() => {
    const updateSize = () => {
      setIsDesktop(desktop.matches);
    };
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, [isDesktop]);

  const getColumnWidth = (isDesktop) =>
    isDesktop ? [200, 100, 'auto', 100] : [40, 'auto', 60];

  const getHeadersItems = (isDesktop) =>
    isDesktop
      ? [
          {
            name: 'Nr projektu',
            sort: 'abbreviation,sorted_number_integer',
            width: '15%',
          },
          { name: 'Rodzaj', sort: 'project_range', width: '10%' },
          { name: 'Tytuł', sort: 'title', width: '60%' },
          { name: 'Głosuj', sort: false, width: '15%' },
        ]
      : [
          { name: 'Rodzaj', sort: 'project_range', width: '15%' },
          { name: 'Tytuł', sort: 'title', width: '55%' },
          { name: 'Głosuj', sort: false, width: '15%' },
        ];

  const getRowsItems = (isDesktop, item) =>
    isDesktop
      ? [
          item.number,
          <Tooltip
            title={
              <Typography variant='body1'>{item.project_range}</Typography>
            }
          >
            <span aria-label={`${item.project_range}`}>
              {cityTypes.includes(item.project_range) ? (
                <LocationCityIcon />
              ) : (
                <MyLocationIcon />
              )}
            </span>
          </Tooltip>,
          <Truncate text={item.title} maxCellWidth={640} withShowBtn={false} />,
          actionGroup(item.id, item.project_range, item.number, item.title),
        ]
      : [
          <span aria-label={`${item.project_range}`}>
            {cityTypes.includes(item.project_range) ? (
              <LocationCityIcon />
            ) : (
              <MyLocationIcon />
            )}
          </span>,
          <>
            <span style={{ color: theme.palette.text.secondary }}>
              {item.number}
            </span>
            <br />
            <Truncate
              text={item.title}
              maxCellWidth={160}
              withShowBtn={false}
            />
          </>,
          actionGroup(item.id, item.project_range, item.number, item.title),
        ];

  const mapFunction = (response) => ({
    headers: getHeadersItems(isDesktop),
    rows: [
      ...response.map((item) => ({
        id: item.id,
        color:
          selectedCityProjects.includes(item.id) ||
          selectedDistrictProjects.includes(item.id)
            ? theme.palette.action.hover
            : 'inherit',
        width: getColumnWidth(isDesktop),
        data: getRowsItems(isDesktop, item),
      })),
    ],
  });

  const handlePhone = (e) => {
    if (
      isNaN(e.key) ||
      isNaN(parseFloat(e.key)) ||
      e.target.value.length > 10
    ) {
      if (e.target.value.length > 10) {
        setWrongCharPhone('Można wpisać maksymalnie 9 cyfr');
      } else {
        setWrongCharPhone('Niepoprawne znaki, dozwolone są tylko cyfry');
      }
      e.preventDefault();
    } else {
      setWrongCharPhone('');
    }
  };

  const handleSpace = (e) => {
    const value = e.target.value;
    const valueWithoutSpaces = value.replaceAll(' ', '');

    if (value.slice(-1) === ' ') {
      e.target.value = value.slice(0, -1);
      e.preventDefault();
    }

    if (valueWithoutSpaces.length > 3 && valueWithoutSpaces.length <= 6) {
      e.target.value =
        valueWithoutSpaces.slice(0, 3) + ' ' + valueWithoutSpaces.slice(3);
    } else if (
      valueWithoutSpaces.length >= 7 &&
      valueWithoutSpaces.length <= 9
    ) {
      e.target.value =
        valueWithoutSpaces.slice(0, 3) +
        ' ' +
        valueWithoutSpaces.slice(3, 6) +
        ' ' +
        valueWithoutSpaces.slice(6);
    }
  };

  const handleVotesSend = async () => {
    const formData = {
      ...user,
      city_projects: selectedCityProjects,
      district_projects: selectedDistrictProjects,
      editionId,
      token: tokenValue,
    };
    try {
      const { status } = await addVote(editionId, formData);
      if (status === 200) {
        setShowSuccessStep(true);
        setShowThirdStep(false);
        window.scrollTo(0, 0);
      }
    } catch (e) {
      enqueueSnackbar('Nie udało się oddać głosu', { variant: 'error' });
    }
  };

  const handleAgreementChecked = (targetValue, name) => {
    setVotesAgreements({...votesAgreements, [name] : targetValue  })
  }

  const displayAgreementsError = (val) => {
    setShowAgreementsError(val)
  }

  const handleBackToFirstStep = () => {
    setShowSecondStep(false);
    setShowThirdStep(false);
    setSelected([]);
    setSelectedCityProjects([]);
    setAvailableVotesForCity(0);
    setSelectedDistrictProjects([]);
    setAvailableVotesForDistrict(0);
    window.scrollTo(0, 0);
  };
  return (
    <>
      {is_active && (
        <Grid container>
          <FaQ fileAddress={file_address} />
          {!showSecondStep && !showThirdStep && !showSuccessStep && (
            <Grid
              item
              xs={12}
              lg={7}
              className={classes.marginCenter}
              ref={formRef}
            >
              <Box className={classes.box}>
                <Grid item xs={12}>
                  <Typography variant='h2' className={classes.subTitle}>
                    Oddaj głos
                  </Typography>
                  <Grid>
                    <ul className={classes.steps}>
                      <li className={classes.stepsItem}>
                        <span
                          className={clsx(
                            classes.stepsCount,
                            classes.stepsCountSelected,
                          )}
                        >
                          1
                        </span>
                        <p style={{ fontSize: '1rem' }}>
                          <strong>Dane personalne</strong>
                        </p>
                      </li>
                      <li className={classes.stepsItem}>
                        <span className={classes.stepsCount}>2</span>
                      </li>
                      <li className={classes.stepsItem}>
                        <span className={classes.stepsCount}>3</span>
                      </li>
                    </ul>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant='h4' className={classes.formTitle}>
                    Dane personalne
                  </Typography>
                  {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                  <FormProvider {...methodsFirstStep}>
                    <form
                      onSubmit={methodsFirstStep.handleSubmit(formSubmit)}
                      className={clsx(classes.filterForm, classes.marginMobile)}
                    >
                      <Grid
                        container
                        spacing={2}
                        className={classes.filterContainer}
                      >
                        <Grid
                          xs={12}
                          item
                          className={classes.withMarginBottomMobile}
                        >
                          <CustomTextField
                            size='small'
                            id='firstName'
                            label='Imię'
                            variant='outlined'
                            name='first_name'
                            required
                            fluidError={false}
                          />
                        </Grid>
                        <Grid
                          xs={12}
                          md={6}
                          item
                          className={classes.withMarginBottomMobile}
                        >
                          <CustomTextField
                            size='small'
                            id='lastName'
                            label='Nazwisko (pierwszy człon)'
                            variant='outlined'
                            name='last_name'
                            required
                            fluidError={false}
                          />
                        </Grid>
                        <Grid
                          xs={12}
                          item
                          md={6}
                          className={classes.withMarginBottomMobile}
                        >
                          <CustomTextField
                            size='small'
                            id='secondLastName'
                            label='Nazwisko (drugi człon)'
                            variant='outlined'
                            name='second_last_name'
                          />
                        </Grid>
                        <Grid xs={12} item>
                          <CustomRadioButtons
                            title='Rodzaj dokumentu'
                            id='hasPesel'
                            required
                            name='has_pesel'
                            handleChange={(e) => handleDocumentTypeChange(e)}
                            radioButtonData={[
                              { name: 'PESEL', id: 'pesel' },
                              {
                                name: 'other',
                                label:
                                  'Inny dokument (dla osób nieposiadających nr PESEL)',
                                id: 'other',
                              },
                            ]}
                          />
                          {documentType !== '' && (
                            <CustomTextField
                              required
                              label={`4 ostatnie cyfry numeru ${
                                documentType === 'other' ? 'dokumentu' : 'PESEL'
                              }`}
                              id='personalId'
                              name='personal_id'
                              size='small'
                              onKeyPress={(e) => handleMask(e)}
                              pattern={/\d{4}/}
                              patternMsg='Wymagane są 4 ostatnie cyfry dokumentu'
                              fluidError={false}
                            />
                          )}
                        </Grid>
                        <Grid xs={12} item>
                          <CustomRadioButtons
                            title='Dane do weryfikacji'
                            id='contactType'
                            name='verification_type'
                            required
                            handleChange={(e) => handleContactTypeChange(e)}
                            radioButtonData={[
                              {
                                name: 'phonenumber',
                                id: 'phonenumber',
                                label: 'numer telefonu',
                              },
                              {
                                name: 'email',
                                label: 'adres e-mail',
                                id: 'email',
                              },
                            ]}
                          />
                          {contactType === 'email' && (
                            <CustomTextField
                              required
                              label='Adres e-mail'
                              id='verificationValue'
                              name='verification_value'
                              size='small'
                              pattern={/\S+@\S+\.\S+/}
                              patternMsg='Zły format adresu email'
                              fluidError={false}
                            />
                          )}
                          {contactType === 'phonenumber' && (
                            <CustomTextField
                              required
                              label='Nr telefonu'
                              id='verificationValue'
                              name='verification_value'
                              size='small'
                              pattern={phoneRegex}
                              patternMsg='Zły format numeru telefonu'
                              fluidError={false}
                              onKeyPress={(e) => handlePhone(e)}
                              handleChange={(e) => handleSpace(e)}
                            />
                          )}
                          {wrongCharPhone && (
                            <p className={classes.warningNoMargin}>
                              {wrongCharPhone}
                            </p>
                          )}
                        </Grid>
                      </Grid>
                      <Grid item xs={12} className={classes.agreement}>
                        <CustomCheckbox
                          id='agreements1'
                          name='agreements1'
                          size='medium'
                          required
                          handleChange={(e) => handleAgreementChecked(e.target.checked, "agreements1")}
                          checkboxData={[
                            {
                              id: 'agreement1',
                              name: 'agreement1',
                              label:
                                'Oświadczam, że zapoznałem (-łam) się z klauzulą informacyjną dotyczącą ochrony moich danych osobowych, dostępną w punkcie do głosowania i na stronie internetowej www.lublin.eu/budzetobywatelski.',
                            },
                          ]}
                        />
                         {showAgreementsError && votesAgreements.agreements1 !== true && (
                            <p className={classes.warningNoMargin}>
                              {agreementRequiredText}
                            </p>
                          )}
                        <CustomCheckbox
                          id='agreements2'
                          name='agreements2'
                          size='medium'
                          required
                          handleChange={(e) => handleAgreementChecked(e.target.checked, "agreements2")}
                          checkboxData={[
                            {
                              id: 'agreement2',
                              name: 'agreement2',
                              label:
                                'Oświadczam, że jestem mieszkanką/mieszkańcem Miasta Lublin.',
                            },
                          ]}
                        />
                         {showAgreementsError && votesAgreements.agreements2 !== true && (
                            <p className={classes.warningNoMargin}>
                              {agreementRequiredText}
                            </p>
                          )}
                        <CustomCheckbox
                          id='agreements3'
                          name='agreements3'
                          handleChange={(e) =>handleAgreementChecked(e.target.checked, "agreements3")}
                          size='medium'
                          required
                          checkboxData={[
                            {
                              id: 'agreement3',
                              name: 'agreement3',
                              label:
                                'Jestem świadomy (-a) możliwości weryfikacji zamieszczonych przeze mnie danych na podstawie dostępnych w Mieście Lublin rejestrów, ewidencji lub innych danych.',
                            },
                          ]}
                        />
                         {showAgreementsError && votesAgreements.agreements3 !== true && (
                            <p className={classes.warningNoMargin}>
                              {agreementRequiredText}
                            </p>
                          )}
                        <Grid item xs={12}>
                          <Box mt={2} mb={2}>
                            <Typography color='error'>
                              Aby głos był ważny, należy zaznaczyć wszystkie
                              oświadczenia.
                            </Typography>
                          </Box>
                        </Grid>
                        <CustomSwitch
                          label='Osoba pełnoletnia'
                          name='is_adult'
                          id='is_adult'
                          defaultValue={true}
                        />
                        {!isAdult && (
                          <>
                            <CustomTextField
                              required
                              label='Imię i nazwisko opiekuna prawnego'
                              id='parent_name'
                              name='parent_name'
                              size='small'
                              fluidError={false}
                              pattern={onlyLettersRegex}
                              patternMsg='To pole zawiera nieprawidłowe znaki'
                            />
                            <CustomCheckbox
                              id='agreements4'
                              name='agreements4'
                              size='medium'
                              required
                              checkboxData={[
                                {
                                  id: 'agreement4',
                                  name: 'agreement4',
                                  label:
                                    'Oświadczam, że jestem rodzicem/opiekunem prawnym wyżej wymienionej osoby.',
                                },
                              ]}
                            />
                            <CustomCheckbox
                              id='agreements5'
                              name='agreements5'
                              size='medium'
                              required
                              checkboxData={[
                                {
                                  id: 'agreement5',
                                  name: 'agreement5',
                                  label:
                                    'Wyrażam zgodę na jej/jego udział w głosowaniu w Budżecie Obywatelskim Miasta Lublin.',
                                },
                              ]}
                            />
                            <CustomCheckbox
                              id='agreements6'
                              name='agreements6'
                              size='medium'
                              required
                              checkboxData={[
                                {
                                  id: 'agreement6',
                                  name: 'agreement6',
                                  label: (
                                    <>
                                      Oświadczam, że zapoznałem (-łam) się z
                                      klauzulą informacyjną dotyczącą ochrony
                                      moich danych osobowych, dostępną w punkcie
                                      do głosowania oraz na stronie{' '}
                                      <a href='https://www.lublin.eu/budzetobywatelski'>
                                        www.lublin.eu/budzetobywatelski{' '}
                                      </a>
                                    </>
                                  ),
                                },
                              ]}
                            />
                          </>
                        )}
                      </Grid>

                      <Grid item xs={12}>
                        <Button
                          variant='contained'
                          color='primary'
                          type='submit'
                          className={classes.submit}
                          onClick={() => displayAgreementsError(false)}
                        >
                          Dalej
                        </Button>
                      </Grid>
                    </form>
                  </FormProvider>
                </Grid>
              </Box>
            </Grid>
          )}
          {!showSecondStep && !showThirdStep && !showSuccessStep && showWk && (
            <TrustedProfile
              votesAgreements={votesAgreements}
              displayAgreementsError={displayAgreementsError}
            />
          )}
        </Grid>
      )}
      <DialogWIthError handleClose={handleClose} isOpen={dialogIsOpen} />

      {!is_active && (
        <Grid container>
          <Grid item xs={12}>
            <Typography variant='h2' className={classes.formTitle}>
              Aktualnie funkcja głosowania jest niedostępna.
            </Typography>
          </Grid>
        </Grid>
      )}
      {/* 2 step */}
      {showSecondStep && (
        <Grid container>
          <Grid item xs={12} lg={7} className={classes.marginCenter}>
            <Box className={classes.box}>
              <Grid item xs={12}>
                <Typography variant='h2' className={classes.subTitle}>
                  Oddaj głos
                </Typography>
                <Grid>
                  <ul className={classes.steps}>
                    <li className={classes.stepsItem}>
                      <span
                        className={clsx(
                          classes.stepsCount,
                          classes.stepsCountSelected,
                        )}
                      >
                        <DoneIcon />
                      </span>
                    </li>
                    <li className={classes.stepsItem}>
                      <span
                        className={clsx(
                          classes.stepsCount,
                          classes.stepsCountSelected,
                        )}
                      >
                        2
                      </span>
                      <p style={{ fontSize: '1rem' }}>
                        <strong>Weryfikacja danych</strong>
                      </p>
                    </li>
                    <li className={classes.stepsItem}>
                      <span className={classes.stepsCount}>3</span>
                    </li>
                  </ul>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Typography variant='h2' className={classes.formTitle}>
                  Weryfikacja danych
                </Typography>
                <Typography className={classes.withMarginBottom}>
                  {user.verification_type === 'email'
                    ? 'Na podany adres e-mail:'
                    : 'Na podany nr telefonu:'}{' '}
                  {user.verification_value} został wysłany kod weryfikacyjny.
                  Sprawdź pocztę i wpisz otrzymany kod poniżej. <br />
                  <br />
                  {user.verification_type === 'email'
                    ? 'Jeżeli nie otrzymasz maila, sprawdź Spam.'
                    : ''}
                </Typography>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <FormProvider {...methodsSecondStep}>
                  <form
                    onSubmit={methodsSecondStep.handleSubmit(
                      verficiationFormSubmit,
                    )}
                    className={classes.filterForm}
                  >
                    <Grid xs={12} item>
                      <CustomTextField
                        size='small'
                        id='token'
                        label='Kod'
                        variant='outlined'
                        name='token'
                        required
                        fluidError={false}
                      />
                    </Grid>
                    <br />
                    <Grid item xs={12}>
                      <Button color='primary' onClick={refreshCode}>
                        Wyślij kod jeszcze raz
                      </Button>
                    </Grid>
                    <Grid item xs={12} className={classes.formFooter}>
                      <Button color='primary' onClick={handleBackToFirstStep}>
                        Wstecz
                      </Button>
                      <Button
                        color='primary'
                        variant='contained'
                        type='submit'
                        style={{ marginLeft: 8 }}
                      >
                        Wyślij
                      </Button>
                    </Grid>
                  </form>
                </FormProvider>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      )}
      {showThirdStep && (
        <Grid container>
          <Grid item xs={12}>
            <Box className={classes.box}>
              <Grid item xs={12}>
                <Typography variant='h2' className={classes.subTitle}>
                  Oddaj głos
                </Typography>
              </Grid>
              <Grid>
                <ul className={classes.steps}>
                  <li className={classes.stepsItem}>
                    <span
                      className={clsx(
                        classes.stepsCount,
                        classes.stepsCountSelected,
                      )}
                    >
                      <DoneIcon />
                    </span>
                  </li>
                  <li className={classes.stepsItem}>
                    <span
                      className={clsx(
                        classes.stepsCount,
                        classes.stepsCountSelected,
                      )}
                    >
                      <DoneIcon />
                    </span>
                  </li>
                  <li className={classes.stepsItem}>
                    <span
                      className={clsx(
                        classes.stepsCount,
                        classes.stepsCountSelected,
                      )}
                    >
                      3
                    </span>
                    <p style={{ fontSize: '1rem' }}>
                      <strong>Projekty</strong>
                    </p>
                  </li>
                </ul>
              </Grid>
              <Grid item xs={12}>
                <Typography variant='h2' className={classes.formTitle}>
                  Projekty
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.votesList}>
                <Typography className={classes.withMarginBottom}>
                  {' '}
                  Ilość głosów do oddania na projekty:{' '}
                </Typography>
                <Typography className={classes.votesListItem}>
                  <MyLocationIcon className={classes.votesIcon} />
                  Dzielnicowe: {availableVotesForDistrict}
                </Typography>
                <Typography className={classes.votesListItem}>
                  <LocationCityIcon className={classes.votesIcon} />
                  Ogólnomiejskie: {availableVotesForCity}
                </Typography>
              </Grid>
              {selected.length > 0 && (
                <Grid item xs={12} className={classes.chipsList}>
                  <Typography>Wybrano:</Typography>
                  {selected.map((el) => {
                    return (
                      <Chip
                        key={el.id}
                        label={
                          <Truncate
                            withShowBtn={false}
                            alwaysTooltip
                            text={`${el.number} ${el.title}`}
                          />
                        }
                        clickable
                        aria-label='Usuń wybrany projekt'
                        className={classes.chip}
                        onDelete={() =>
                          handleRemoveSelectProject(el.id, el.objType)
                        }
                        deleteIcon={
                          <ClearIcon
                            style={{
                              color: theme.palette.primary.contrastText,
                            }}
                          />
                        }
                      />
                    );
                  })}
                </Grid>
              )}
              <Grid item xs={12}>
                <CustomTable
                  service={(values) => fetchProjectsData(values)}
                  mapFunction={mapFunction}
                  loading={loading}
                  count={count}
                  data={approved}
                  title='Lista projektów oddanych pod głosowanie'
                  haveSearch
                  haveFilters
                  filtersData={filterData}
                  defaultSort='abbreviation,sorted_number_integer'
                  rowsLimit={50}
                  withMinWidth={false}
                />
              </Grid>
              <Grid item xs={12} className={classes.agreement}>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <FormProvider {...methodsThirdStep}>
                  <form
                    onSubmit={methodsThirdStep.handleSubmit(handleVotesSend)}
                    className={classes.filterForm}
                  >
                    <Grid item xs={12} className={classes.formFooter}>
                      <Button color='primary' onClick={handleBackToFirstStep}>
                        Wstecz
                      </Button>
                      <Button
                        color='primary'
                        variant='contained'
                        type='submit'
                        style={{ marginLeft: 8 }}
                      >
                        Zagłosuj
                      </Button>
                    </Grid>
                  </form>
                </FormProvider>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      )}
      {showSuccessStep && <SuccessStep classes={classes} selected={selected} />}
    </>
  );
};

export default Votes;

Votes.propTypes = {
  editionId: PropTypes.string.isRequired,
};

if (document.querySelector('#votesForm') !== null) {
  ReactDOM.render(
    <Wrapper productionPrefix='vot' seed='votes'>
      <Votes editionId={edition} />
    </Wrapper>,
    document.getElementById('votesForm'),
  );
}
